module.exports = __webpack_public_path__ + "img/business.d3a2b172.svg";